// import { mount } from 'svelte'
// import './app.css'
// import App from './App.svelte'
// const app = mount(App, {
//   target: document.getElementById('app')!,
// })
// export default app
import { mount, unmount } from 'svelte';
import { defaultConfig } from 'tailwind-variants';

import '@fontsource-variable/noto-sans';
import '@fontsource-variable/outfit';
import './main.css';

import { TeoCore } from '../../teoCore/TeoCore';

import '../../webComponents/LoginElement.svelte';
import '../../webComponents/TPIDashboardElement.svelte';
import '../../webComponents/ConfigPanelElement.svelte';
import '../../webComponents/AssistantElement.svelte';
import '../../webComponents/ProfileElement.svelte';
import '../../webComponents/TeoTabsElement.svelte';
import '../../webComponents/TeoSideNavElement.svelte';
import '../../webComponents/DebugElement.svelte';
import '../../webComponents/TeoDialogsElement.svelte';
import '../../webComponents/LoginScreenElement.svelte';

import EditorComponent from '../../lib/ui/components/editor/EditorComponent.svelte';
import SideBySideEditorElement from '../../lib/ui/components/SideBySideEditor/SideBySideEditorElement.svelte';

import '@fontsource-variable/noto-sans';
import '@fontsource-variable/outfit';

import { TeoText } from '@/teoCore/text/TeoText';
import type { TeoView } from '@/teoCore/text/TextUi';
import EditorHeadlineComponent from '@/ui/components/editor/EditorHeadlineComponent.svelte';

// TODO: not sure where to do this best:
// probably it is best to use `tvt` from `@/ui/tv` instead of `tv` from `tailwind-variants`
defaultConfig.twMerge = false;

async function main() {
  const teoCore = await TeoCore.init({
    elements: [
      'teo-assistant',
      'teo-config-panel',
      'teo-loginscreen',
      'teo-sidenav',
      'teo-profile',
      'teo-tabs',
      'teo-tpi-dashboard',
      'teo-debug',
      'teo-dialogs',
      'teo-side-by-side-editor',
    ],
    apiBaseUrl: 'https://api-dev.teo.digital/',
    useInsecureHttp: false,
    evaluationProfile: 3,
  });
  window.teoCore = teoCore;
  window.__TEO__getCore = () => teoCore;

  if (teoCore.user.isLoggedIn) {
    document.body.classList.add('logged-in');
  } else {
    document.body.classList.remove('logged-in');
  }

  teoCore.user.events.addEventListener('logIn', () => {
    document.body.classList.add('logged-in');
  });

  teoCore.user.events.addEventListener('logOut', () => {
    document.body.classList.remove('logged-in');
  });

  mount(EditorComponent, {
    target: document.getElementById('teo-editor')!,
    props: {
      teoCore,
    },
  });

  mount(EditorHeadlineComponent, {
    target: document.getElementById('teo-editor-headline')!,
    props: {
      teoCore,
    },
  });

  // Registers the first active text
  if (teoCore.activeText) registerActiveText(teoCore, teoCore.activeText);

  // Registeres new texts if text change
  teoCore.events.addEventListener('activeTextChanged', (detail: TeoText) => {
    registerActiveText(teoCore, detail);
    // Update view
    switchEditorView(teoCore, teoCore.activeText.ui.state.view);
  });
}

let removeEventListerView: (() => void) | undefined = undefined;
let sideBySideEditor: SideBySideEditorElement;
let mountedView: TeoView | undefined = undefined;

function registerActiveText(teoCore: TeoCore, activeText: TeoText): void {
  // Remove old listener
  removeEventListerView?.();

  // Add new listener
  removeEventListerView = activeText.ui.events.addEventListener('view', (value: TeoView) => {
    switchEditorView(teoCore, value);
  });
}

function switchEditorView(teoCore: TeoCore, value: TeoView): void {
  const three = document.getElementById('editor-with-sidebars');
  const two = document.getElementById('side-by-side-editor');

  if (three && two) {
    // SideBySide editor will be mounted
    if (value === 'plain-language') {
      // Mount side by side editor
      sideBySideEditor = mount(SideBySideEditorElement, {
        target: document.getElementById('teo-side-by-side-editor')!,
        props: {
          teoCore,
        },
      });

      three.classList.add('editor-view-hidden');
      two.classList.remove('editor-view-hidden');
    }
    // SideBySide editor will be unmounted
    else if (mountedView === 'plain-language') {
      // Unmount side by side editor
      unmount(sideBySideEditor);
      three.classList.remove('editor-view-hidden');
      two.classList.add('editor-view-hidden');
    }
  }
  mountedView = value;
}

main()
  .then(() => console.log('teo3-app mounted'))
  .catch(console.error);
